import { render, staticRenderFns } from "./InsurancesPlanDelete.vue?vue&type=template&id=05e6bfc4&scoped=true&"
import script from "./InsurancesPlanDelete.vue?vue&type=script&lang=js&"
export * from "./InsurancesPlanDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e6bfc4",
  null
  
)

export default component.exports